// for the hover for the menu items
var windowWidth = window.innerWidth;
if (windowWidth > 989) {
	var listMenuDetails = document.querySelectorAll(".list-menu details");

	listMenuDetails.forEach(function(item) {
		item.addEventListener("mouseenter", function() {
			this.setAttribute("open", "");
			this.querySelector(".header__menu-item").classList.add("active");
		});

		item.addEventListener("mouseleave", function() {
			this.removeAttribute("open");
			this.querySelector(".header__menu-item").classList.remove("active");
		});
	});
}
